/* tslint:disable */
/* eslint-disable */

/**
 * Type of item. Can be:
 *   * PRODUCT
 *   * MODIFIER
 *   * COMPOSITE
 *   * GROUPED_PRODUCT
 */
export enum ItemType {
  Product = 'PRODUCT',
  Modifier = 'MODIFIER',
  Composite = 'COMPOSITE',
  GroupedProduct = 'GROUPED_PRODUCT'
}
